import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
export var socialClipboardCopy = function socialClipboardCopy() {
  Alpine.data('socialClipboardCopy', function () {
    return {
      linkHref: '',
      copied: false,
      init: function init() {
        this.link = this.$el;
        this.linkHref = this.link.getAttribute('href');
      },
      bindLink: {
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          var _this = this;
          if (this.linkHref) {
            navigator.clipboard.writeText(this.linkHref);
            this.copied = true;
            setTimeout(function () {
              _this.copied = false;
            }, 1500);
          }
        }
      }
    };
  });
};